var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIvaLogoBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 21,
    viewBox: "0 0 55 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_1498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2223 0.550171L10.9385 5.41233H4.13379L5.46532 0.550171H12.2223Z",
    fill: "#003391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4356 7.31702L6.95574 20.5H0L3.61102 7.31702H10.4356Z",
    fill: "#003391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0928 5.41233H14.7813L13.8125 0.550171H20.967L22.0928 5.41233Z",
    fill: "#003391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8664 7.31702L25.4427 19.8784L24.932 20.5H17.7864L17.6771 19.9496V19.9486L15.1602 7.31702H22.5332L23.5796 11.8323L26.6639 7.31702H35.8664Z",
    fill: "#003391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2871 0.60022L37.531 5.41225H28.248L31.7478 0.60022H41.2871Z",
    fill: "#003391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8199 5.41228H39.5977L43.7711 0.5H50.8262L51.8199 5.41228Z",
    fill: "#003391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9998 20.4498H47.8453L45.858 12.3295H34.0332L38.4054 7.31702H52.3169L53.3105 12.3295L54.9998 20.4498Z",
    fill: "#003391"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_1498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvaLogoBlue);
export default __webpack_public_path__ + "static/media/iva-logo-blue.bcede7284a9aebe12da976cac13ee730.svg";
export { ForwardRef as ReactComponent };